import { FC } from 'react'
import CookieConsent, { Cookies } from 'react-cookie-consent'
import classNames from 'classnames'
import i18next from '@/i18n'

export const CookieConsentComponent: FC = () => {
  return (
    <CookieConsent
      containerClasses="!bg-white !text-primary !justify-center"
      location="bottom"
      contentClasses="!flex-none text-[14px] !m-[20px] break-all max-sm:w-full max-sm:px-5"
      buttonText={i18next.t('ui.accept_all_cookies')}
      buttonClasses={classNames(
        '!bg-primary !active:bg-blue-600 !text-white !rounded',
        'min-h-[40px] h-[40px] !px-4 text-sm'
      )}
      enableDeclineButton
      declineButtonText={i18next.t('ui.reject_cookies')}
      declineButtonClasses={classNames(
        '!border !border-primary !border-solid !border-1 !bg-white !text-primary !rounded',
        'min-h-[40px] h-[40px] !px-6 text-sm'
      )}
      cookieName="cookie-consent"
      cookieValue="accept"
      declineCookieValue="reject"
      expires={150}
    >
      {i18next.t('ui.cookie_notice')}
    </CookieConsent>
  )
}
